// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay-2CScv","base":"base-1VfVQ"};